import { YM, YMInterval } from '../utils/YearMonth';

export const DATA_COLLECTION_DATA_PROCESSING_OFFSET_IN_DAYS = 7;
export const REVIEW_AND_PROCESSING_SLA = 14;

export const DATA_COLLECTION_MIN_LENGTH = 7;

export const FOOTPRINT_DEFAULT_LENGTH = 14;

export const SHORTEST_MEASUREMENT_IN_DAYS =
  DATA_COLLECTION_MIN_LENGTH +
  DATA_COLLECTION_DATA_PROCESSING_OFFSET_IN_DAYS +
  3;

export const MEASUREMENT_MAX_INTERVAL = new YMInterval(
  YM.make(2017),
  YM.make(new Date().getFullYear() + 2)
);
